<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'view',
    subject: 'Dashboard',
  },
})

const page = {
  groupTitle: 'Administrasi',
  icon: 'ri-dashboard-line',
  color: 'error',
  title: 'Dashboard & Laporan',
  description: 'Membaca dashboard sesuai peran dan mengekspor 6 laporan wajib.',
  purpose: 'Panduan membaca dashboard yang tampilannya menyesuaikan peran Anda, dan cara mengekspor laporan.',
  concept: [
    {
      icon: 'ri-user-star-line',
      title: 'Dashboard Berbeda per Peran',
      text: 'Direktur melihat Dashboard Direksi (ringkasan lintas unit), Ketua Tim Mutu melihat Dashboard Tim Mutu (detail operasional), Kepala Unit melihat Dashboard Unit (data unitnya sendiri) — semua otomatis, tidak perlu dipilih manual.',
    },
    {
      icon: 'ri-file-download-line',
      title: '6 Laporan Wajib',
      text: 'Audit Trail, IKP, Indikator Mutu, CAPA, MFK, dan Pegawai — semuanya bisa diekspor ke PDF atau Excel dengan filter periode dan unit.',
    },
  ],
  steps: [
    { title: 'Buka menu Dashboard', detail: 'Widget yang tampil otomatis menyesuaikan peran Anda.' },
    { title: '(Khusus Dashboard Unit) Pilih unit Anda lewat dropdown yang muncul', detail: 'Sistem tidak bisa menebak unit Anda otomatis, jadi perlu dipilih sekali.' },
    { title: 'Buka menu Laporan untuk mengekspor', detail: 'Pilih jenis laporan, atur filter periode dan unit, klik "Terapkan" untuk pratinjau.' },
    { title: 'Klik "Export PDF" atau "Export Excel"', detail: 'File langsung terunduh ke komputer Anda.' },
  ],
  tips: [
    'Laporan Audit tidak punya filter unit — karena catatan aktivitas sistem memang lintas seluruh modul, tidak terikat satu unit tertentu.',
  ],
  faq: [
    { q: 'Kenapa saya tidak bisa mengekspor laporan padahal bisa melihat Dashboard?', a: 'Melihat Dashboard dan mengekspor Laporan adalah dua izin terpisah — hubungi admin kalau Anda memang perlu akses ekspor laporan.' },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
